/* eslint-disable */
/// This file is auto generated - do not edit manually
export * as Subscription from './trans-website-pos-subscription';
export * as Samples from './trans-website-pos-samples';
export * as Refund from './trans-website-pos-refund';

export const Brands = 'Website.Pos.Brands';
export const Menu = 'Website.Pos.Menu';
export const Booking = 'Website.Pos.Booking';
export const BookingMyProfile = 'Website.Pos.BookingMyProfile';
export const SamplesHeading = 'Website.Pos.SamplesHeading';
export const RefundHeading = 'Website.Pos.RefundHeading';
export const Search = 'Website.Pos.Search';
export const LoginFailed = 'Website.Pos.LoginFailed';
export const LoginRequired = 'Website.Pos.LoginRequired';
export const AssistantUsageSuggestion = 'Website.Pos.AssistantUsageSuggestion';
export const Error = 'Website.Pos.Error';
